import Actions from './actions';

import * as Reducers from './reducers';

export default {
  Reducers,
  Actions,
};
